"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//@ts-nocheck
/**
 * Handle complete tooltips
 *
 * @namespace
 * @memberOf txGs1Base
 * @public
 */
const _main_1 = require("./_main");
_main_1.txGs1Base.complete = {
    checkIfMustBeProtected: function () {
        return !$('body').hasClass('mw-logged-in');
    },
    initialize: function () {
        'use strict';
        _main_1.txGs1Base.complete.tooltip.initialize();
        // select all protected links
        $('body').on('click', 'a[href*=return_url]', function (event) {
            event.preventDefault();
            var $link = $(this);
            var languageUid = $('.login-form-container').attr('data-language-uid');
            var actionUrl = _main_1.txGs1Base.login.actionUrl + (languageUid === undefined ? '' : '&L=' + parseInt(languageUid));
            if (_main_1.txGs1Base.complete.checkIfMustBeProtected()) {
                _main_1.txGs1Base.login.pollLoginCallback = function () {
                    if (_main_1.txGs1Base.login.isLoggedIn) {
                        $.fancybox.close();
                        $('a[href*=return_url]').each(function (i, link) {
                            var transformedHref = _main_1.txGs1Base.complete.transformCompleteReturnUrl($link.attr('href'));
                            if (transformedHref.length > 0) {
                                $(link).prop('href', transformedHref);
                            }
                        });
                        if ($link.attr('data-download-href')) {
                            window.open($link.attr('data-download-href'));
                        }
                        else {
                            var transformedHref = _main_1.txGs1Base.complete.transformCompleteReturnUrl($link.attr('href'));
                            if (transformedHref.length > 0) {
                                window.location.href = transformedHref;
                            }
                        }
                    }
                };
                $.fancybox.open([{
                        href: actionUrl
                    }], {
                    type: 'ajax',
                    ajax: {
                        dataType: 'html',
                        cache: 'false'
                    },
                    live: false,
                    margin: 0,
                    padding: 50,
                    openMethod: 'modalIn',
                    tpl: {
                        wrap: '<div class="fancybox-wrap" id="fancybox" tabIndex="-1"><div class="fancybox-skin modal-dialog"><div class="fancybox-outer modal-content"><div class="fancybox-inner modal-body"></div></div></div></div>',
                        error: '<p class="fancybox-error">The requested content cannot be loaded.<br/>Please try again later.</p>',
                        closeBtn: '<button class="fancybox-item fancybox-close close"><span aria-hidden="true">×</span><span class="sr-only">Close</span></button>'
                    },
                    helpers: {
                        title: {
                            type: 'inside',
                            position: 'bottom'
                        },
                        overlay: {
                            locked: false
                        }
                    },
                    afterShow: function () {
                        $.eventEmitter.emit('contentUpdate');
                        $('.modal-dialog').animate({
                            top: 0,
                            opacity: 1
                        }, 500, function () {
                            _main_1.txGs1Base = _main_1.txGs1Base || {};
                            _main_1.txGs1Base.content.lightbox = _main_1.txGs1Base.content.lightbox || {};
                            _main_1.txGs1Base.content.lightbox.isActive = true;
                        });
                    }
                });
            }
            else {
                window.open($link.attr('data-download-href'));
            }
        });
    },
    /**
     * Transform return url from complete links
     *
     * @param href
     * @return {String}
     */
    transformCompleteReturnUrl: function (href) {
        href = href.replace('gs1-complete/login/?return_url=', '');
        // due to #8457 (GSONE-172)
        href = href.replace(/.*\/\/[^\/]*/, '');
        if (href.charAt(0) === "/") {
            href = href.substr(1);
        }
        href = decodeURIComponent(href).replace(/&pageId=[0-9]{1,4}/, '');
        // Make sure href is an absolute link
        // Mobile Internet Explorer seems to cut off the leading slash for some reasons - GSONE-1278
        if (href.substr(0, 4) !== 'http' && href.substr(0, 1) !== '/') {
            href = '/' + href;
        }
        return href;
    }
};
exports.default = {};
